import { render, staticRenderFns } from "./rule-configs.vue?vue&type=template&id=031cd2d5&scoped=true"
import script from "./rule-configs.vue?vue&type=script&lang=js"
export * from "./rule-configs.vue?vue&type=script&lang=js"
import style0 from "./rule-configs.vue?vue&type=style&index=0&id=031cd2d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031cd2d5",
  null
  
)

export default component.exports